export const Gender = [
    {
        
    }
]
export const COLORS = {
	PRIMARY: "#00a465",
	PRIMARY_LIGHT: "#0fb877",
	PRIMARY_DARK: "#078a58",
	BACKGROUND_COLOR: "#f0f8fe",
	BACKGROUND_COLOR_LIGHT: "#F9FCFF",
	BACKGROUND_GREEN: "#f0fef9",
	BACKGROUND_GREEN_DARK: "#e1f5ee",
	DANGER: "#e94220",
	DANGER_LIGHT: "#f24d2c",
	DANGER_DARK: "#d43c1d",
	DISABLED: "#d2d5d6",
	WHITE: "#fff",
	BLACK: "#121617",
	GREY1: "#4d5556",
	GREY2: "#6c7375",
	GREY3: "#a1a6a7",
	GREY4: "#e8e8e8",
	BORDER: "#d9d9d9",
	INACTIVE_HEADING: "#354052",
	PERSIAN_GREEN: "#009ca4",
	BACKGROUND_GREY: "#fafafa",
	BACKGROUND_BLUE: "#f0f8fe",
	YELLOW: "#f5ae0a",
	PICTON_BLUE: "#23b2eb",
	BLUE : "rgb(54, 84, 227)"
};

export default COLORS;